(ns machtfit.startpage.views
  (:require [machtfit.app.routes :as routes]
            [machtfit.app.tracking :as tracking]
            [machtfit.core :as machtfit]
            [machtfit.feedback :as feedback]
            [machtfit.startpage.catalog :as catalog]
            [machtfit.startpage.emarsys :as emarsys]
            [machtfit.startpage.events :as events]
            [machtfit.startpage.footer :as footer]
            [machtfit.startpage.header :as header]
            [machtfit.startpage.icons :as icons]
            [machtfit.startpage.spinner :as spinner]
            [machtfit.startpage.subs :as subs]
            [machtfit.stepchall.views :as stepchall.views]
            [machtfit.translation :refer [tr t]]
            [machtfit.widgets.badge :as badge]
            [machtfit.widgets.button :as button]
            [machtfit.widgets.icon :as icon]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn- notification [{:keys [title content id button-text]}]
  [:div.notification-2019
   [:div.notification__wrapper
    [:h4 title]
    [:div.notification__content {:dangerouslySetInnerHTML (r/unsafe-html content)
                                 :on-click (fn [e]
                                             (.preventDefault e)
                                             (when-let [closest-anchor (.closest (.-target e) "a")]
                                               (rf/dispatch [::events/close-notification-clicked id])
                                               (set! (.-href js/window.location) (.getAttribute closest-anchor "href"))))}]
    [:div.notification__bottom
     [:button.btn-2019 {:style {:background-color @(rf/subscribe [:get [:subdomain-info :base-color]])}
                        :data-ph-capture-attribute-ui_id (tracking/compose-ui-id "startpage-notification" "close")
                        :on-click #(rf/dispatch [::events/close-notification-clicked id])}
      button-text]]]])

(rf/reg-event-fx ::survey-notification-tracking
  (fn [{:keys [db]} [_ ph-ui-id display-count type]]
    {::tracking/capture-ui-event [db
                                  "survey_notification"
                                  ph-ui-id
                                  {:display_count display-count
                                   :type type}]}))

(defn- survey-notification [_]
  (r/create-class
   {:component-did-mount
    (fn [this]
      (let [[_ {:keys [close-count]}] (r/argv this)]
        (rf/dispatch [::survey-notification-tracking "sees_onsite_feedback_survey_promo_q2_2026" (inc close-count) "displayed"])))
    :reagent-render
    (fn [{:keys [id url close-count]}]
      (let [display-count (inc close-count)]
        [:div.fixed.top-0.left-0.x-0.w-full.h-full.flex.justify-center.items-center
         {:class ["bg-black/[.67]"
                  "z-[3000]"]}
         [:div.w-full.bg-white.rounded-2xl.shadow.flex.flex-col.justify-start.items-center
          {:class ["max-w-[480px]"]}
          [:div.flex.flex-col.justify-start.items-center
           [:div.px-6.pt-6.flex.flex-col.self-stretch.justify-start.items-start.gap-8
            [:div.flex.self-stretch.items-center.justify-between
             [:div.flex.justify-start.items-center.gap-4.min-w-64
              [:img.w-28 {:src (machtfit/static "img/machtfit-logo.png")}]
              [badge/pill-outline {:text (t {:de "Online Umfrage"
                                             :en "Online Survey"})
                                   :color :brand
                                   :size :lg}]]
             [:div.cursor-pointer {:on-click #(rf/dispatch [::events/close-survey-notification-clicked id display-count])}
              [icon/outline "x-close"]]]
            [:div.self-stretch.justify-center.items-start.gap-1.inline-flex
             [:div.grow.shrink.basis-0.flex-col.justify-start.items-start.inline-flex
              [:h3.font-bold.leading-snug.text-gray-900 (t {:de "Gestalte mit und gewinne mit etwas Glück!"
                                                            :en "Help shape it and win!"})]
              [:ul.list-disc.pl-5.text-gray-800.text-sm.mt-0
               [:li (t {:de "1× E-Bike"
                        :en "1× E-Bike"})]
               [:li (t {:de "2× Höhenverstellbarer Schreibtisch und Stuhl"
                        :en "2× Height-adjustable desk and chair"})]
               [:li (t {:de "1× Jahresmitgliedschaft in einem Fitnessstudio deiner Wahl"
                        :en "1× Annual gym membership of your choice"})]]]
             [:img.w-24 {:src (machtfit/static "img/bycicle.png")}]]]]
          [:div.flex.self-stretch.justify-center.items-center
           [:div.p-6.w-full.flex.flex-col.gap-3
            [button/button
             {:text [t {:de "Jetzt teilnehmen!"
                        :en "Participate now!"}]
              :full-width? true
              :attrs {:href url
                      :target "_blank"
                      :on-click #(rf/dispatch [::survey-notification-tracking "starts_onsite_feedback_survey_promo_q2_2026" display-count "started"])}}]
            [:a.inline-flex.w-full.justify-center.cursor-pointer.text-base.text-gray-800
             {:on-click #(rf/dispatch [::events/close-survey-notification-clicked id display-count])}
             (t {:de "Jetzt nicht"
                 :en "Not now"})]]]]]))}))

(defn- modal []
  (when-let [content @(rf/subscribe [:get [:ui :modal-content]])]
    [:div.modal
     {:on-click #(rf/dispatch [:set-path [:ui :modal-content] nil])}
     [:div.modal__wrapper
      ;; we don't want clicks on the content to close the modal
      {:on-click #(.stopPropagation %)}
      content]]))

(defn error-panel []
  [:div.api-error
   [icons/mf-rib-background]
   [:div.api-error__container
    [:span.api-error__logo
     [icons/mf-supersign-white]]
    [:h2.api-error__title (tr "Oops... Etwas ist schief gelaufen!")]
    [:a.btn-2019.btn-2019--ghost
     {:on-click #(rf/dispatch [::events/reload])}
     (tr "Plattform neu laden")]]])

(defn navigation-header []
  (let [show-breadcrumbs? (not (and @(rf/subscribe [::subs/is-app?])
                                    (= @(rf/subscribe [:get [:ui :page :id]]) :stepchall)))]
    [:<>
     [header/header]
     (when show-breadcrumbs?
       [:<> [header/breadcrumbs-component]
        [header/mobile-breadcrumbs-component]])]))

(defn error-404 []
  [:<>
   [:div.error-container
    [:div.container.container-xl
     [:div.error-header
      [:h1 (t {:de "404 – Seite nicht gefunden"
               :en "404 – Page not found"})]]]]
   [:div.container
    [:a
     (routes/attrs-link-to-page {:id :home})
     [:button.back-to-platform-button
      (t {:de "Zurück zur Plattform"
          :en "Back to the platform"})]]]])

(defn startpage []
  (if (and @(rf/subscribe [::subs/show-error?]) (not js/goog.DEBUG))
    [error-panel]
    (let [page-id @(rf/subscribe [:get [:ui :page :id]])
          root (case page-id
                 :404 error-404
                 :catalog catalog/product-list
                 :stepchall stepchall.views/stepchall
                 nil)
          wait-for-startpage-data? (#{:catalog
                                      :stepchall} page-id)
          is-app? @(rf/subscribe [::subs/is-app?])
          is-app-v2? @(rf/subscribe [::subs/app-version-2?])
          is-stepchall? (= :stepchall @(rf/subscribe [:get [:ui :page :id]]))
          first-notification @(rf/subscribe [::subs/first-notification])
          survey @(rf/subscribe [:get [:user :survey]])
          overlaid? @(rf/subscribe [:get [:ui :appointments-product-id]])
          overlaid-transparently? @(rf/subscribe [:get [:ui :user-menu-open?]])]
      [:div#startpage {:on-click #(when (or overlaid? overlaid-transparently?)
                                    (rf/dispatch [::events/overlay-clicked]))
                       :class (when overlaid?
                                "overlaid")}
       [emarsys/emarsys-ribbons]
       (cond
         survey [survey-notification survey]
         (and (not= :catalog page-id) first-notification) [notification first-notification]
         (and (not= :catalog page-id) (not first-notification)) [emarsys/emarsys-overlay])
       [modal]
       (when-not (and is-app? is-stepchall?)
         [navigation-header])
       (if (or (nil? root)
               (and wait-for-startpage-data?
                    (not @(rf/subscribe [::subs/startpage-data-loaded?]))))
         [spinner/spinner]
         [root])
       (when-not (or is-app-v2?
                     (and is-app? is-stepchall?))
         [footer/footer])
       [feedback/feedback-button-spa]])))
